import { FormattedMessage } from 'react-intl';
import { PoolActionLabel } from '@synergy/components-next';
import { ReactElement } from 'react';

export const ArticleCardVariantLabel = (): ReactElement => {
    return (
        <PoolActionLabel
            variant="small"
            color="dark"
            hasSkew={false}
            sx={{ backgroundColor: theme => theme.palette.grey[800] }}
        >
            <FormattedMessage id="app.article.variants" />
        </PoolActionLabel>
    );
};
